import React, { useState } from "react";
import { ProjectItems } from "./NavItems";
import { Link } from "react-router-dom";
import "./Dropdown.css";
import GoToTop from "./GoToTop";

function DropdownP() {
  const [dropdownP, setDropdownP] = useState(false);

  return (
    <>
      <ul
        className={dropdownP ? "submenu clicked" : "submenu"}
        onClick={() => setDropdownP(!dropdownP)}
      >
        {ProjectItems.map((item) => {
          return (
            <li key={item.id}>
              <Link
                to={item.path}
                className={item.cName}
                onClick={() => {setDropdownP(false);GoToTop();}}
              >
                {item.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default DropdownP;
